var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.62 38.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.31,0A19.31,19.31,0,1,1,0,19.31,19.32,19.32,0,0,1,19.31,0Z",
    transform: "translate(0 0)",
    fill: "#005454",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.21 7.36 23.58 14.07 31.31 16.15 26.28 22.38 26.69 30.38 19.21 27.52 11.73 30.38 12.14 22.38 7.1 16.15 14.84 14.07 19.21 7.36",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.15 21.92 19.04 18.95 8.39 16.49 13.15 21.92",
    fill: "#005454",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.66 14.39 19.05 18.95 19.11 9.17 15.66 14.39",
    fill: "#005454",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.07 26.36 19.04 18.95 12.66 29.05 19.07 26.36",
    fill: "#005454",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.39 22.03 19.04 18.95 25.84 29.14 25.39 22.03",
    fill: "#005454",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.95 14.73 19.04 18.95 29.97 16.43 22.95 14.73",
    fill: "#005454",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB7);
export default __webpack_public_path__ + "static/media/B7.469a7488f25992f3448c5e7ac71b7899.svg";
export { ForwardRef as ReactComponent };